/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { initWidget } from '@wiwo/card-selector';
import * as ReactDOMServer from 'react-dom/server';
import CardSelectorPopUp from './shared/CardSelectorPopup/CardSelectorPopUp';
import Cards from './shared/CardSelectorPopup/Constants';
import SelectorContent from './CardSelectorComponents/SelectorContent';
import ImportantUpdate from './CardSelectorComponents/ImportantUpdate';

const CardSelector = (props) => {
    const elRef = useRef(null);
    const { config } = props;
    const [isLoadPopUp, setIsLoadPopUp] = useState(false);
    const [applyOnlineLink, setApplyOnlineLink] = useState('');
    const [applyNetBankLink, setApplyNetBankLink] = useState('');

    // Get selector content data from the hidden field
    const selectorContentData = window.selectorContentData ? JSON.parse(window.selectorContentData) : {};

    const handleLoadPopUp = () => {
        setIsLoadPopUp(!isLoadPopUp);
    };
    const onApplyFn = (e) => {
        const keyElem = document.getElementById('PageData');
        const pageData = JSON.parse(keyElem.value ? keyElem.value : '');

        // Helper function to set links and show the popup
        const applyLinks = (deepLinkKey) => {
            setApplyNetBankLink(`${pageData?.folUrl}/${deepLinkKey}`);
            setApplyOnlineLink(`${pageData?.folNewToBankUrl}`);
            handleLoadPopUp();
        };

        let deepLinkKey = null;

        if (selectorContentData) {
            // Get all card objects from the API data (array of card objects)
            const allCardObjects = Object.values(selectorContentData)
                .filter((value) => typeof value === 'object' && value !== null && value.salesProductCode);

            // Find cards that matches the productID
            const cardData = allCardObjects.find((card) => card.salesProductCode === e.productId);
            deepLinkKey = cardData?.deepLinkKey;

            if (deepLinkKey) {
                applyLinks(deepLinkKey);
                return;
            }
        }
        // Fallback to Cards constant if no deepLink key found in data
        const selectedCard = Cards.find((card) => card.id === e.productId);
        deepLinkKey = selectedCard?.deepLinkKey;
        if (deepLinkKey) {
            applyLinks(deepLinkKey);
        } else {
            console.error('Could not find Netbank/Online link');
        }
    };

    /**
     * Renders SelectorContent as HTML string
     * Injects rendered HTML into the no-result-module which is inside the template element
     * Initialises the card selector widget with updated template config
    */
    function renderSelectorContent(configData) {
        // get existing aem template thing, generate HTML string, find no-result and set the HTML.
        const existingTemplate = document.querySelector('template.aem-content');

        const htmlContent = ReactDOMServer.renderToString(<SelectorContent initialCardData={selectorContentData} />);

        const noResultModule = existingTemplate.content.querySelector('.no-result-module');

        noResultModule.innerHTML = htmlContent; // set the HTML content

        const prop = {
            config: configData,
            container: elRef.current,
            contentEl: existingTemplate,
            onApply: (e) => onApplyFn(e),
        };
        initWidget(prop);

        // Inject Important Update banner into Q1 and results screens if data is present
        const importantUpdateData = selectorContentData?.disclaimers?.importantUpdate;
        if (!importantUpdateData) return;

        const bannerHtml = ReactDOMServer.renderToString(
            <ImportantUpdate
                heading={importantUpdateData.heading}
                body={importantUpdateData.body}
                learnMoreText={importantUpdateData.learnMoreText}
                learnMoreUrl={importantUpdateData.learnMoreUrl}
            />,
        );

        const widgetContainer = elRef.current;

        const injectionPoints = [
            {
                // Q1 screen: insert after the question heading (h2), before the radio options
                guard: '.survey__question__q1-opening',
                insertAfter: '.survey__question-label',
                modifier: 'important-update--q1',
            },
            {
                // Results screen: insert after the "We've found these credit cards for you" heading
                guard: '.card-result__card-result-title',
                insertAfter: '.card-result__card-result-title',
                modifier: 'important-update--results',
            },
        ];

        const observer = new MutationObserver(() => {
            injectionPoints.forEach(({
                guard, insertBefore, insertAfter, modifier,
            }) => {
                const guardEl = widgetContainer.querySelector(guard);
                if (!guardEl || widgetContainer.querySelector(`.${modifier}`)) return;
                const node = document.createElement('div');
                node.innerHTML = bannerHtml;
                const banner = node.firstElementChild;
                banner.classList.add(modifier);
                if (insertAfter) {
                    const afterEl = widgetContainer.querySelector(insertAfter);
                    if (afterEl) {
                        afterEl.parentNode.insertBefore(banner, afterEl.nextSibling);
                    }
                } else if (insertBefore) {
                    const targetEl = widgetContainer.querySelector(insertBefore);
                    if (targetEl) {
                        targetEl.parentNode.insertBefore(banner, targetEl);
                    }
                }
            });
        });

        observer.observe(widgetContainer, { childList: true, subtree: true });
    }

    useEffect(() => {
        renderSelectorContent(config);
    }, [config]);

    return (
        <div className="widget-example">
            <div ref={elRef} />
            {isLoadPopUp ? (
                <CardSelectorPopUp
                    handlePopUp={handleLoadPopUp}
                    applyOnlineLink={applyOnlineLink}
                    applyNetbankLink={applyNetBankLink}
                />
            ) : null }
        </div>
    );
};

// eslint-disable-next-line import/prefer-default-export
export default CardSelector;
